module.exports = __webpack_public_path__ + "img/quickCheckBanner.0256fe8.webp";